import React, { FormEvent, useState } from 'react';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';
import PasswordInput from '../../../common/input/password-input/PasswordInput';

import { ReactComponent as EmailIcon } from '../../../../resources/icons/email.svg';

import './delete-account.scss';

type Props = {
  accountDeleted: boolean;
  handleDeleteAccountClick: (email: string, password: string) => void;
};

const DeleteAccount = ({ accountDeleted, handleDeleteAccountClick }: Props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    handleDeleteAccountClick(email, password);
  };

  return (
    <AuthLayout>
      <section className="delete-account">
        {accountDeleted ? (
          <section className="delete-account__content">
            <h1 className="delete-account__content__heading">Account Deleted</h1>

            <p className="delete-account__content__message">Your account has been successfully deleted.</p>
          </section>
        ) : (
          <>
            <section className="delete-account__content">
              <h1 className="delete-account__content__heading">We&apos;re sorry to see you go</h1>

              <p className="delete-account__content__message">
                If you are sure you would like to delete your account, confirm by logging in below.
              </p>

              <p className="delete-account__content__message">This action cannot be undone.</p>
            </section>

            <form className="delete-account__form" onSubmit={handleSubmit}>
              <section className="delete-account__input-container">
                <section className="delete-account__input">
                  <EmailIcon className="delete-account__email-icon" />
                  <input
                    type="text"
                    value={email}
                    onChange={({ target }) => setEmail(target.value)}
                    placeholder="email"
                  />
                </section>
                <PasswordInput
                  value={password}
                  onChange={({ target }) => setPassword(target.value)}
                  placeholder="password"
                />
              </section>

              <section className="delete-account__button-container">
                <Button text="Delete Account" disabled={!email || !password} onClick={handleSubmit} auth />
              </section>
            </form>
          </>
        )}
      </section>
    </AuthLayout>
  );
};

export default DeleteAccount;
